import React, { useRef, useState } from "react";
import { menuItems as rawMenuItems } from "../../utils/constants";
import { useLocation, useNavigate } from "react-router-dom";
import {
  IonHeader,
  IonTitle,
  IonToolbar,
  IonMenu,
  IonList,
  IonItem,
  IonContent,
  IonButtons,
  IonButton,
  IonLabel,
  IonIcon,
  IonActionSheet,
} from "@ionic/react";
import { menuOutline, closeOutline, chevronBack } from "ionicons/icons";

function HeaderApp() {
  const location = useLocation();
  const pathname = location.pathname;
  const partesDoCaminho = pathname.split("/");
  const primeiroCaminho = partesDoCaminho[1];
  const segundoCaminho = partesDoCaminho[2];
  const [actionSheetNumero, setActionSheetNumero] = useState(false);

  const navigate = useNavigate();
  const menu = useRef();

  const returnNamePath = (rota) => {
    if (rota === "inicio") {
      if (primeiroCaminho === "empresas") {
        return "Início";
      } else {
        return "Agendar horário";
      }
    } else if (rota === "agendamentos") {
      return "Agendamentos";
    } else if (rota === "agendar") {
      return "Agendar horário";
    } else if (rota === "agendamento") {
      return "Agendamento";
    } else if (rota === "agendamentos-dia") {
      return "Agendamentos do dia";
    } else if (rota === "conta") {
      return "Perfil";
    } else if (rota === "servicos") {
      return "Serviços";
    } else if (rota === "clientes") {
      return "Clientes";
    } else if (rota === "dias_nao_atendidos") {
      return "Dias não atendidos";
    } else if (rota === "configuracoes_horario_atendimento") {
      return "Horários de atendimento";
    } else if (rota === "configuracoes") {
      return "Configurações";
    } else if (rota === "calendario-semana") {
      return "Agendamentos da semana";
    } else if (rota === "dashboard") {
      return "Dashboard";
    } else if (rota === "calendario") {
      return "Agenda";
    } else if (rota === "suporte") {
      return "Suporte";
    } else if (rota === "consumo") {
      return "Consumo";
    } else if (rota === "sugestoes") {
      return "Sugestões/Melhorias";
    } else if (rota === "dias_excessao") {
      return "Datas de excessão";
    } else if (rota === "inicio-custom") {
      return "Mais opções";
    } else if (rota === "confirmacao") {
      return "Confirmação do Agendamento";
    } else {
      return "Rota não localizada";
    }
  };

  const logout = () => {
    document.cookie =
      "token_usuario_agendou" +
      "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    localStorage.removeItem("tipoUsuario");
    window.location.href = "/";
  };

  const modalLogout = () => {
    setActionSheetNumero(true);
  };

  const menuItems = rawMenuItems.map((item) =>
    item.path === "logout" ? { ...item, action: modalLogout } : item
  );

  return (
    <>
      <IonActionSheet
        isOpen={actionSheetNumero}
        header={`Deseja realmente sair da conta atual?`}
        buttons={[
          {
            text: "Sim",
            role: "destructive",
            handler: () => logout(),
          },
          {
            text: "Fechar",
            role: "cancel",
            handler: () => {
              return;
            },
          },
        ]}
        onDidDismiss={() => setActionSheetNumero(false)}
      ></IonActionSheet>
      <IonHeader mode="ios">
        <IonToolbar>
          {primeiroCaminho === "empresas" ? (
            <IonButtons slot="end">
              <IonButton
                onClick={() => {
                  menu.current.open();
                }}
              >
                <IonIcon
                  style={{ fontSize: 20, color: "#000000" }}
                  icon={menuOutline}
                ></IonIcon>
              </IonButton>
            </IonButtons>
          ) : null}
          <IonButtons slot="start">
            <IonButton
              onClick={() => {
                navigate(-1);
              }}
            >
              <IonIcon
                style={{ fontSize: 20, color: "#000000" }}
                icon={chevronBack}
              ></IonIcon>
            </IonButton>
          </IonButtons>

          <IonTitle>{returnNamePath(segundoCaminho)}</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonMenu ref={menu} side="start" contentId="main-content">
        <IonHeader mode="md">
          <IonToolbar>
            <IonButtons slot="start">
              <IonButton
                onClick={() => {
                  menu.current.setOpen(false);
                }}
              >
                <IonIcon style={{ fontSize: 20 }} icon={closeOutline}></IonIcon>
              </IonButton>
            </IonButtons>
            <IonTitle>Menu</IonTitle>
          </IonToolbar>
        </IonHeader>
        <IonContent>
          <IonList>
            {menuItems.map(({ path, icon, label, action }) => (
              <IonItem
                key={path}
                button
                onClick={() => (action ? action() : navigate(path))}
              >
                <IonLabel>
                  <i className={icon}></i> &nbsp; {label}
                </IonLabel>
              </IonItem>
            ))}
          </IonList>
        </IonContent>
      </IonMenu>
    </>
  );
}
export default HeaderApp;
